// IS A SCRIPT DRIVING THIS BROWSER? (2026-10-18, TW-0352 item 12)
//
// The site's rule, written the same way (apps/marketing/lib/scripted.ts): WebDriver's own flag. Every automation harness
// sets `navigator.webdriver` (Playwright, Puppeteer, Selenium, a headless Chrome) and no person's browser does, so it is
// the one mark a scripted walk carries without anybody remembering to add it. The beacon stamps such a row `internal`,
// the mark every read already leaves out, and `scripted` beside it, so a read names it a script and never "our own
// marked browsers" (beacon.ts row()).
//
// Until this file the form marked only a browser marked by hand (`?wt_internal=1`, internal.ts), so a walk of a real
// shop's form on Playwright read as a client at that shop's counter: the texting walks of 2026-10-17 drove real shops'
// forms in a headless browser while the site's own rows of the same walks read `internal` + `scripted`.
//
// AND THE SIGNING (TW-0352, later the same day): internal.ts internalFields posts it with the submission too, `internal` and
// `scripted` beside it, so a walk that signs a real shop's form counts as no client either (the API stamps `internal` on the
// row, the mark owner_signature.not_a_client reads). A person's POST body is still the one it has been since 2023, and
// nothing is unlocked or refused by it.

/** True only when the browser says a script drives it; a browser that will not say is a person's. */
export function isScripted(
  nav: { webdriver?: boolean } | undefined = typeof navigator === "undefined" ? undefined : navigator
): boolean {
  try {
    return nav?.webdriver === true;
  } catch {
    return false;
  }
}
